import { useCallback } from 'react';

import type { Id } from '@e-socna/data-layer';

import { usePrinterContext } from '../../../contexts/PrinterContext/hooks/usePrinterContext.hook';
import type { OnPrintHandler } from '../../../components/DocumentEditor/types/props.type';

import { useQueryInvalidation } from './useQueryInvalidation.hook';

interface Params {
  readonly sectionTemplateId: Id;
  readonly snackbarActionTarget: string;
}

export const usePrintHandler = ({
  sectionTemplateId,
  snackbarActionTarget,
}: Readonly<Params>) => {
  const { queryKeyToInvalidate } = useQueryInvalidation(sectionTemplateId);

  const { print } = usePrinterContext();

  const onPrint = useCallback<OnPrintHandler>(
    (params) => {
      print({
        ...params,
        printableId: sectionTemplateId,
        snackbarActionTarget,
        command: 'printSectionTemplate',
        queryKeysToInvalidate: [queryKeyToInvalidate],
      });
    },
    [sectionTemplateId, print, queryKeyToInvalidate, snackbarActionTarget],
  );

  return {
    onPrint,
  };
};
